import { ErrorAlert } from "components/atoms/Alert"
import { Button } from "components/atoms/Button"
import { Spin } from "components/atoms/Spin"
import { Detail } from "components/atoms/detail/Detail"
import { DetailHeader } from "components/atoms/detail/DetailHeader"
import { DetailTable } from "components/atoms/detail/DetailTable"
import { DetailTableRow } from "components/atoms/detail/DetailTableRow"
import { DetailTitle } from "components/atoms/detail/DetailTitle"
import { NotFound } from "components/molecules/404"
import { deserializeTimestamp } from "deserializers/deserializeTimestamp"
import { useInitializeAccountData } from "hooks/useInitializeAccountData"
import { useAsyncLoading } from "hooks/useLoading"
import React, { useState, useEffect, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { useRecoilValue } from "recoil"
import { companyState } from "recoils/companyState"
import { isInitializingFinishedState } from "recoils/initializingState"
import {
  isClientNotFoundState,
  isCompanyNotFoundState,
} from "recoils/isNotFoundState"

import { deserializeTimestamp2 } from "../../deserializers/deserializeTimestamp"

export const CompanyPage: React.VFC = () => {
  const [error, setError] = useState("")
  const [loading, asyncLoading] = useAsyncLoading("companyIndex")
  const company = useRecoilValue(companyState)

  const isClientNotFound = useRecoilValue(isClientNotFoundState)
  const isCompanyNotFound = useRecoilValue(isCompanyNotFoundState)
  const isInitialized = useRecoilValue(isInitializingFinishedState)
  const navigate = useNavigate()

  const initialize = useInitializeAccountData()
  useEffect(() => {
    asyncLoading(
      initialize().catch((e) => {
        setError(e.message)
      }),
    )
    // MEMO: 初回描画のみ実行する
  }, [])

  useEffect(() => {
    if (isInitialized && isCompanyNotFound) {
      navigate("edit")
    }
  }, [isInitialized])

  const planList = ["無料プラン", "プランA", "プランG"]

  const planLabel = useMemo(() => {
    if (!company?.plan) return ""

    return ` (${company.planLabel})`
  }, [company])

  if (isInitialized && isClientNotFound) {
    return <NotFound />
  }
  return loading ? (
    <Spin />
  ) : (
    <Detail>
      <DetailHeader>
        <DetailTitle>会社情報</DetailTitle>
        <Button
          isLoading={loading}
          className={"primary"}
          onClick={() => {
            navigate("edit")
          }}
        >
          編集
        </Button>
      </DetailHeader>
      <DetailTable>
        <DetailTableRow label="会社名・屋号">
          {company && company.name}
        </DetailTableRow>
        <DetailTableRow label="代表者名">
          {company && company.representativeName}
        </DetailTableRow>
        <DetailTableRow label="担当者名">
          {company && company.staffName}
        </DetailTableRow>
        <DetailTableRow label="従業員数">
          {company && company.employeesNumber} 名
        </DetailTableRow>
        <DetailTableRow label="電話番号">
          {company && company.telephoneNumber}
        </DetailTableRow>
        <DetailTableRow label="メールアドレス">
          {company && company.email}
        </DetailTableRow>
        <DetailTableRow label="利用プラン">
          {company && planList[company.plan]}
          {planLabel}
        </DetailTableRow>
        <DetailTableRow label="利用開始日">
          {company && deserializeTimestamp2(company.createdAt)}
        </DetailTableRow>
        <DetailTableRow label="会社概要">
          {company && company.overview}
        </DetailTableRow>
      </DetailTable>
      {error && <ErrorAlert>{error}</ErrorAlert>}
    </Detail>
  )
}
